import { defineMessages } from 'react-intl';

var messages = defineMessages({
  ariaLabel: {
    id: "neptune.CloseButton.ariaLabel"
  }
});

export { messages as default };
//# sourceMappingURL=CloseButton.messages.mjs.map
